if (document.documentElement.lang.split('-')[0] === 'hu') {
/* Reposition Kbite's real button; preserve its app-owned listeners and form. */
(function () {
  'use strict';
  if (customElements.get('pb-cro-back-in-stock')) return;
  class BackInStock extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('.product-info');
      this.widgetSlot = this.querySelector('[data-pb-back-in-stock-slot]');
      this.variant = JSON.parse(this.querySelector('[data-pb-bis-variant]').textContent);
      this.eventName = `eurus:product-page-variant-select:updated:${this.dataset.section}`;
      this.onVariant = event => {
        const data = event.detail?.html?.querySelector('[data-selected-variant]');
        if (data) { try { this.variant = JSON.parse(data.textContent); } catch (_) { this.variant = null; } }
        else this.variant = null;
        this.sync();
      };
      document.addEventListener(this.eventName, this.onVariant);
      this.observer = new MutationObserver(() => {
        if (this.queued) return;
        this.queued = true;
        queueMicrotask(() => { this.queued = false; if (this.isConnected) this.sync(); });
      });
      if (this.scope) this.observer.observe(this.scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-variant-id', 'data-product-id', 'style'] });
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener(this.eventName, this.onVariant);
    }
    sync() {
      const id = this.variant?.id ? String(this.variant.id) : '';
      const eligible = !!id && this.variant.available === false;
      const candidates = [...(this.scope?.querySelectorAll('.gw-button-widget[data-product-id]') || [])].filter(b => b.dataset.productId === this.dataset.productId);
      const button = eligible && candidates.find(b => b.dataset.variantId === id);
      for (const candidate of candidates) candidate.hidden = candidate !== button;
      this.widgetSlot.hidden = !button;
      if (!button) return;
      button.type = 'button';
      if (button.textContent !== 'Kérek értesítést') button.textContent = 'Kérek értesítést';
      if (button.parentElement !== this.widgetSlot) this.widgetSlot.append(button);
      if (this.widgetSlot.dataset.variantId !== id) this.widgetSlot.dataset.variantId = id;
      if (!this.scrolled && window.location.hash === '#pb-back-in-stock') {
        this.scrolled = true; this.scrollIntoView({ block: 'center' });
      }
    }
  }
  customElements.define('pb-cro-back-in-stock', BackInStock);
})();

} else {
/* Reposition Kbite's real button; preserve its app-owned listeners and form. */
(function () {
  'use strict';
  if (customElements.get('pb-cro-back-in-stock')) return;
  class BackInStock extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('.product-info');
      this.widgetSlot = this.querySelector('[data-pb-back-in-stock-slot]');
      this.variant = JSON.parse(this.querySelector('[data-pb-bis-variant]').textContent);
      this.eventName = `eurus:product-page-variant-select:updated:${this.dataset.section}`;
      this.onVariant = event => {
        const data = event.detail?.html?.querySelector('[data-selected-variant]');
        if (data) { try { this.variant = JSON.parse(data.textContent); } catch (_) { this.variant = null; } }
        else this.variant = null;
        this.sync();
      };
      document.addEventListener(this.eventName, this.onVariant);
      this.observer = new MutationObserver(() => {
        if (this.queued) return;
        this.queued = true;
        queueMicrotask(() => { this.queued = false; if (this.isConnected) this.sync(); });
      });
      if (this.scope) this.observer.observe(this.scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-variant-id', 'data-product-id', 'style'] });
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener(this.eventName, this.onVariant);
    }
    sync() {
      const id = this.variant?.id ? String(this.variant.id) : '';
      const eligible = !!id && this.variant.available === false;
      const candidates = [...(this.scope?.querySelectorAll('.gw-button-widget[data-product-id]') || [])].filter(b => b.dataset.productId === this.dataset.productId);
      const button = eligible && candidates.find(b => b.dataset.variantId === id);
      for (const candidate of candidates) candidate.hidden = candidate !== button;
      this.widgetSlot.hidden = !button;
      if (!button) return;
      button.type = 'button';
      if (button.textContent !== 'Anunță-mă') button.textContent = 'Anunță-mă';
      if (button.parentElement !== this.widgetSlot) this.widgetSlot.append(button);
      if (this.widgetSlot.dataset.variantId !== id) this.widgetSlot.dataset.variantId = id;
      if (!this.scrolled && window.location.hash === '#pb-back-in-stock') {
        this.scrolled = true; this.scrollIntoView({ block: 'center' });
      }
    }
  }
  customElements.define('pb-cro-back-in-stock', BackInStock);
})();

}
